// Plantillas de informe detallado (constantes frontend). Cada plantilla es una lista de
// páginas en el MODELO DEL BUILDER ({ type, visible, settings }); aplicarla = volcar estas
// páginas al builder/configurador → auto-enlace → al aplicar se escribe reports.detailed.
// Portable: sin groupId ni imagen (se re-vinculan por proyecto). Base x-elio derivada del
// análisis real.
import { TYPES } from './page-builder.render'

// Crea una página del builder: defaults del tipo + overrides.
function pg(type, visible, settings) {
  return { type, visible: visible !== false, settings: Object.assign({}, TYPES[type].defaults(), settings || {}) }
}

// Disciplinas estándar x-elio (4 imágenes por disciplina). MM usa pictograma (sin imagen de
// plano); LEV/BESS vienen ocultas por alcance. Portable: sin groupId.
const weeklyDisciplines = () => [
  pg('discipline', true, { discipline: 'OC', name: 'CIVIL WORK', imageSource: 'plan', userCanDefineLegend: true, numberOfExtraImages: 4 }),
  pg('discipline', true, { discipline: 'MM', name: 'MECHANICAL INSTALLATION', imageSource: 'none', userCanDefineLegend: false, numberOfExtraImages: 4 }),
  pg('discipline', true, { discipline: 'ME', name: 'ELECTRICAL INSTALLATION', imageSource: 'plan', userCanDefineLegend: false, numberOfExtraImages: 4 }),
  pg('discipline', false, { discipline: 'LEV', name: 'EVACUATION LINE', imageSource: 'plan', userCanDefineLegend: false, numberOfExtraImages: 4 }),
  pg('discipline', true, { discipline: 'SET', name: 'SUBSTATION', imageSource: 'plan', userCanDefineLegend: true, numberOfExtraImages: 4 }),
  pg('discipline', false, { discipline: 'BESS', name: 'BESS INSTALLATION', imageSource: 'plan', userCanDefineLegend: false, numberOfExtraImages: 4 }),
]

// "Semanal" (recomendada) — grupos PADRE. GENERAL 6 imágenes; disciplinas 4; curva S con
// scheduled + current; tabla: schedule + current% (fija) + unidad + % programado.
const weeklyPages = () => [
  pg('cover', true, {}),
  pg('dashboard', true, { showGroupProgress: 'parent' }),
  pg('groupcharts', true, { scheduled: true, current: true, lastPlanned: false }),
  pg('tasktable', true, { schedule: true, actual: false, latest: false, currentUnit: true, scheduledPct: true, latestPct: false }),
  pg('images', true, { numberOfExtraImages: 6 }),
  ...weeklyDisciplines(),
  pg('gantt', true, { numberOfImages: 2 }),
]

// "Semanal · subgrupos" — igual que la anterior pero dashboard por HIJOS y la tabla añade
// las columnas Actual.
const weeklyChildrenPages = () => [
  pg('cover', true, {}),
  pg('dashboard', true, { showGroupProgress: 'children' }),
  pg('groupcharts', true, { scheduled: true, current: true, lastPlanned: false }),
  pg('tasktable', true, { schedule: true, actual: true, latest: false, currentUnit: true, scheduledPct: true, latestPct: false }),
  pg('images', true, { numberOfExtraImages: 6 }),
  ...weeklyDisciplines(),
  pg('gantt', true, { numberOfImages: 2 }),
]

// "Semanal · extendida" — como la primera (grupos PADRE) pero curva S con 3 líneas
// (scheduled + current + última programada) y tabla con schedule + actual + current% + % programado.
const weeklyExtendedPages = () => [
  pg('cover', true, {}),
  pg('dashboard', true, { showGroupProgress: 'parent' }),
  pg('groupcharts', true, { scheduled: true, current: true, lastPlanned: true }),
  pg('tasktable', true, { schedule: true, actual: true, latest: false, currentUnit: false, scheduledPct: true, latestPct: false }),
  pg('images', true, { numberOfExtraImages: 6 }),
  ...weeklyDisciplines(),
  pg('gantt', true, { numberOfImages: 2 }),
]

// "Ejecutivo" — para dirección: portada + dashboard (PADRE) + gráficos por grupo (scheduled +
// current) + imágenes.
const executivePages = () => [
  pg('cover', true, {}),
  pg('dashboard', true, { showGroupProgress: 'parent' }),
  pg('groupcharts', true, { scheduled: true, current: true, lastPlanned: false }),
  pg('images', true, {}),
]

// "Personalizada" = mínimo editable: portada + dashboard, y el usuario añade.
const customPages = () => [
  pg('cover', true, {}),
  pg('dashboard', true, {}),
]

// key en inglés; name = etiqueta visible (ES). Orden: Semanal (reco), subgrupos, extendida,
// Ejecutivo, Personalizada.
export const REPORT_TEMPLATES = [
  { key: 'weekly', name: 'Semanal', reco: true, desc: 'Base completa: portada, dashboard (grupos padre), gráficos por grupo, tabla, GENERAL, disciplinas y Gantt.', pages: weeklyPages },
  { key: 'weekly_children', name: 'Semanal · subgrupos', reco: false, desc: 'Como la Semanal pero el dashboard muestra subgrupos y la tabla añade las fechas reales (Actual).', pages: weeklyChildrenPages },
  { key: 'weekly_extended', name: 'Semanal · extendida', reco: false, desc: 'Semanal con curva S de 3 líneas (programado, ejecutado y última programada) y tabla ampliada.', pages: weeklyExtendedPages },
  { key: 'executive', name: 'Ejecutivo', reco: false, desc: 'Para dirección: portada, dashboard, gráficos por grupo e imágenes.', pages: executivePages },
  { key: 'custom', name: 'Personalizada', reco: false, desc: 'Empieza mínimo (portada + dashboard) y añade lo que necesites.', pages: customPages },
]

export function templatePages(key) {
  const t = REPORT_TEMPLATES.find((x) => x.key === key)
  return t ? t.pages() : null
}
